enum AdswizzReportView {
  Genre = 'Genre',
}

export default AdswizzReportView;
